<template>
  <div>
    <sex-selector-constraint
      v-if="type === optionValue.sex"
      :allowed-values.sync="sexAllowedValues"
      :forbidden-values.sync="sexForbiddenValues"
    />
    <currency-selector-constraint
      v-else-if="type === optionValue.currency"
      :allowed-values.sync="currencyAllowedValues"
      :forbidden-values.sync="currencyForbiddenValues"
    />
    <other-selector-constraint
      v-else
      :data-source.sync="customSourceValues"
      :allowed-values.sync="otherAllowedValues"
      :forbidden-values.sync="otherForbiddenValues"
    />
  </div>
</template>

<script>
import OtherSelectorConstraint from "@/components/excel/designer/configure/value/other/SelectorConstraint";
import SexSelectorConstraint from "@/components/excel/designer/configure/value/other/sex-selector-constraint";
import CurrencySelectorConstraint from "@/components/excel/designer/configure/value/other/currency-selector-constraint";
import {
  CurrencyOption,
  OtherOption,
  SexOption,
} from "@/components/excel/schema/value/type/other";

export default {
  name: "other-single-selector-constraint",
  components: {
    CurrencySelectorConstraint,
    SexSelectorConstraint,
    OtherSelectorConstraint,
  },
  props: {
    type: {
      type: Number,
    },
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
    customSource: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    forbiddenValues(values) {
      this.sex.forbiddenValues = [];
      this.currency.forbiddenValues = [];
      this.other.forbiddenValues = [];
      switch (this.$props.type) {
        case this.optionValue.sex:
          this.sex.forbiddenValues = values || [];
          break;
        case this.optionValue.currency:
          this.currency.forbiddenValues = values || [];
          break;
        case this.optionValue.other:
          this.other.forbiddenValues = values || [];
      }
    },
    allowedValues(values) {
      this.sex.allowedValues = [];
      this.currency.allowedValues = [];
      this.other.allowedValues = [];
      switch (this.$props.type) {
        case this.optionValue.sex:
          this.sex.allowedValues = values || [];
          break;
        case this.optionValue.currency:
          this.currency.allowedValues = values || [];
          break;
        case this.optionValue.other:
          this.other.allowedValues = values || [];
      }
    },
  },
  computed: {
    sexAllowedValues: {
      get() {
        return this.sex.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.sex.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    currencyAllowedValues: {
      get() {
        return this.currency.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.currency.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    otherAllowedValues: {
      get() {
        return this.other.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.other.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    sexForbiddenValues: {
      get() {
        return this.sex.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.sex.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    currencyForbiddenValues: {
      get() {
        return this.currency.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.currency.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    otherForbiddenValues: {
      get() {
        return this.other.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.other.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    customSourceValues: {
      get() {
        return this.$props.customSource || [];
      },
      set(value) {
        this.emitChangeCustomSource(value);
      },
    },
  },
  data() {
    return {
      sex: {
        allowedValues: null,
        forbiddenValues: null,
      },
      currency: {
        allowedValues: null,
        forbiddenValues: null,
      },
      other: {
        allowedValues: null,
        forbiddenValues: null,
      },
      optionValue: {
        sex: SexOption.value,
        currency: CurrencyOption.value,
        other: OtherOption.value,
      },
    };
  },
  methods: {
    emitChangeAllowedValues(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    emitChangeForbiddenValues(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
    emitChangeCustomSource(value) {
      this.$emit("update:custom-source", value);
      this.$emit("change-custom-source", value);
    },
  },
};
</script>
